import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Button, Paper, Typography } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./home.css";
import { fetchHighlightsImageList } from "../../features/home/highlightsSlice";
import { useAppDispatch, useAppSelector } from "../../helpers/hooks";
import UpdateHighlights from "./updateHighlights";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Loader from "../loader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import ImageUploadModal from "./imageUploadModal";

export default function Highlight() {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = React.useState(true);
  const imageList = useAppSelector((state) => state.highlightsImages.imageList);
  const [open, setOpen] = React.useState(false);
  const [listOfFeaturedImages, setListOfFeaturedImages] = React.useState([]);
  const user = useAppSelector((state) => state.userProfile.profile);
  const [uploadHighlightsImgModal, setUploadHighlightsImgModal] =
    React.useState(false);

  const openUpdateHighlights = () => {
    setOpen(true);
  };

  const uploadHighlightsImages = () => {
    setUploadHighlightsImgModal(true);
  };
  const handlePopupClose = () => {
    setOpen(false);
  };

  const handleImgModalClose = () => {
    setUploadHighlightsImgModal(false);
  };

  React.useEffect(() => {
    if (imageList.length > 0) {
      let list = imageList?.filter((list: any) => list.featured !== false);
      setListOfFeaturedImages(list);
    }
  }, [imageList]);

  React.useEffect(() => {
    dispatch(fetchHighlightsImageList()).then((res) => {
      if (res.meta.requestStatus == "fulfilled") {
        setIsLoading(false);
      }
    });
  }, []);

  return (
    <React.Fragment>
      <Container>
        <Box mb={1} sx={{ flexGrow: 1 }}>
          <Grid pt={4} pb={4} alignItems="center" container rowSpacing={1}>
            <Grid size={{ sm: 12 }}>
              <Typography variant="h3" textAlign="center">
                Highlights
              </Typography>
            </Grid>
            {user && user.userType == "ADMIN" && (
              <>
                <Button
                  variant="contained"
                  className="highlights-btn"
                  onClick={uploadHighlightsImages}
                >
                  + Upload
                </Button>
              </>
            )}
            &nbsp; &nbsp;
            {user && user.userType == "ADMIN" && (
              <>
                <Button
                  variant="contained"
                  className="highlights-btn"
                  onClick={openUpdateHighlights}
                >
                  <ModeEditIcon fontSize="small" sx={{ paddingRight: "5px" }} />{" "}
                  Edit
                </Button>
              </>
            )}
          </Grid>
        </Box>

        <Box mb={8} sx={{ flexGrow: 1 }}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, sm: 12 }}>
              {isLoading ? (
                <Loader />
              ) : (
                <Carousel
                  swipeable={false}
                  draggable={false}
                  showDots={false}
                  responsive={responsive}
                  ssr={true}
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={1800}
                  keyBoardControl={true}
                  customTransition="all 2s ease-in-out"
                  transitionDuration={500}
                  containerClass="carousel-container"
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  itemClass="carousel-item-padding-40-px"
                  arrows={true}
                >
                  {listOfFeaturedImages &&
                    listOfFeaturedImages.map((item, i) => (
                      <Item key={i} item={item} />
                    ))}
                </Carousel>
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
      {open && (
        <UpdateHighlights
          open={open}
          handleClose={handlePopupClose}
          imageList={imageList}
        />
      )}
      {uploadHighlightsImgModal && (
        <ImageUploadModal
          open={uploadHighlightsImgModal}
          handleClose={handleImgModalClose}
          imageList={imageList}
        />
      )}
    </React.Fragment>
  );
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

function Item(props: any) {
  return (
    <Paper>
      <LazyLoadImage
        alt={""}
        height={240}
        src={props.item.imageUrl}
        width={"95%"}
      />
    </Paper>
  );
}
